import React, { useState, useEffect } from 'react'; 
import { useNavigate } from 'react-router-dom';
import Header from '../components/header';
import './LoginPage.css';

const API_URL = "/api";

function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  // If there's already a token in localStorage, redirect to dashboard.
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      navigate('/dashboard');
    }
  }, [navigate]);

  const handleLogin = async (e) => {
    e.preventDefault();
    setErrorMessage('');
    setIsLoading(true);

    try {
      console.log('Attempting login with:', { email, password: '********' });
      console.log('Using API URL:', API_URL);

      const response = await fetch(`${API_URL}/auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
      });

      console.log('Login response status:', response.status);

      // Check if response is JSON before attempting to parse it
      const contentType = response.headers.get('content-type');
      if (!contentType || !contentType.includes('application/json')) {
        const textResponse = await response.text();
        console.error('Received non-JSON response:', textResponse.substring(0, 100) + '...');
        throw new Error('Server returned an invalid response. Contact administrator.');
      }

      const data = await response.json();

      if (!response.ok) {
        console.log('Login error response data:', data);
        throw new Error(data.error || 'Invalid credentials');
      }

      console.log('Login success data:', data);

      // Store token in localStorage
      if (data.token) {
        localStorage.setItem('token', data.token);
        console.log('Token stored in localStorage:', localStorage.getItem('token'));

        // If user data is returned, store it too (optional)
        if (data.user) {
          localStorage.setItem('user', JSON.stringify(data.user));
        }

        // Redirect to dashboard
        navigate('/dashboard');
      } else {
        throw new Error('No token returned from server');
      }
    } catch (error) {
      console.error('Login Error:', error);
      setErrorMessage(error.message || 'Failed to connect to the server. Please try again later.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Header />

      <div className="login-container">
        <div className="login-image-container">
          <img 
            src="https://i.imgur.com/05zwRJK.jpeg" 
            alt="Kelowna lakeside view" 
            className="login-image"
          />
          <div className="login-image-overlay">
            <div className="login-tagline">
              <h2>Discover Local Stores</h2>
              <p>Connect with businesses in your community</p>
            </div>
          </div>
        </div>
        
        <div className="login-form-container">
          <div className="login-form-wrapper">
            <div className="login-logo">
              <h1 className="login-logo-text">StoreToyou</h1>
            </div>
            
            <form onSubmit={handleLogin} className="login-form">
              {errorMessage && <div className="login-error">{errorMessage}</div>}
              
              <div className="form-group">
                <input
                  type="email"
                  placeholder="Email address"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  className="login-input"
                />
              </div>
              
              <div className="form-group">
                <input
                  type="password"
                  placeholder="Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  className="login-input"
                />
              </div>
              
              <button 
                type="submit" 
                className="login-button"
                disabled={isLoading}
              >
                {isLoading ? 'Logging in...' : 'Log in'}
              </button>
            </form>
            
            <div className="login-divider">
              <span>OR</span>
            </div>
          </div>
          
          <div className="signup-container">
            <p>
              Don't have an account? <a href="/register" className="signup-link">Sign up</a>
            </p>
          </div>
        </div>
      </div>
    </>
  );
}

export default LoginPage;
